import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { UserResponse } from "@/types";

type Props = {
  page?: string | null,
  per_page?: number | null,
  search?: string | null
  roles?: string | null;
  account_type?: string | null;
}

async function fetchUsers(
  { page, roles, search, per_page, account_type }: Props
): Promise<UserResponse> {
  const pageParams = `page=${page || 1}&per_page=${per_page}&search=${search ?? ""
    }&roles=${roles || ''}&account_type=${account_type || ''}`;
  const response = await httpRequest.get<UserResponse>(`/users?${pageParams}`);
  return response.data;
}

export function useFetchUsersQuery({
  page,
  per_page,
  search,
  account_type,
  roles
}: Props) {
  const usersQuery = useQuery({
    queryKey: ["users", page || "1", per_page, search, account_type, roles],
    queryFn: () => fetchUsers({ page, per_page, search, account_type, roles }),
    keepPreviousData: true,
  });

  return {
    ...usersQuery,
    data: usersQuery.data,
  };
}
